import { ProductTab as SourceProductTab } from 'SourceComponent/ProductTab/ProductTab.component';

/** @namespace Advox/Component/ProductTab/Component */
export class ProductTab extends SourceProductTab {
    render() {
        const { tabName, isActive } = this.props;

        return (
            <li block="ProductTab" elem="Item" mods={{ isActive }}>
                <button mix={{ block: 'ProductTab', elem: 'Button' }} onClick={this.onClick}>
                    {tabName}
                </button>
            </li>
        );
    }
}

export default ProductTab;
